import { Component, Input, ViewChild } from '@angular/core';
import Swal from "sweetalert2";
import {DocumentoProcessoService} from "../../services/documento-processo.service";
import {ItemDocumento, ListaDocumento} from "../../models/lista-documento";
import {ToastrService} from "ngx-toastr";
import {DatePipe} from "@angular/common";
import { finalize } from 'rxjs';
import { NovoComponent } from '../pages/novo/novo.component';

@Component({
    selector: 'app-documento-processo-lista',
    templateUrl: './lista.component.html',
    styleUrl: './lista.component.css',
    standalone: false
})
export class ListaComponent {
  @ViewChild(NovoComponent) novoDocumentoComponent: NovoComponent;
  @Input() loading = false;
  public colunas = [`Id`, `Arquivo`, 'Processo', 'Extensão', 'Data'];
  public linhas: any[] = [];
  listaDocumentos = new ListaDocumento();
  documentosAgrupados: { pasta: string, documentos: any[], aberta: boolean }[] = [];
  paginaAtual = 1;
  filtro = '';

  constructor(private documentoService: DocumentoProcessoService,
              private toastr: ToastrService,
              private datePipe: DatePipe) {
    this.buscarListaDocumentoProcesso();
  }

  abrirModalNovoDocumento(){
    this.novoDocumentoComponent.showModalNovoDocumento();
  }

  public pageChange(event: number){
    this.paginaAtual = event;
  }

  public buscarListaDocumentoProcesso(){
    this.loading = true;
    this.documentoService.selecionarLista()
      .pipe(finalize(() => this.loading = false))
      .subscribe({
        next: (response: any) => {
          if(response.sucesso){
            this.listaDocumentos = response.dados;
            this.agruparDocumentos();
            this.preencherLista(response.dados.itens);
          }
        },
        error: (error: any) => {
          if(error.status === 404){
            this.toastr.warning("Lista de documentos vazia");
          }
          else{
            this.toastr.error("Erro ao buscar a listagem - HTTP " + error.status );
          }
        }
      });
  }

  agruparDocumentos() {
    const grupos = (this.listaDocumentos.itens || []).reduce((acc, documento) => {
      const pasta = documento.pasta || 'Sem Pasta';
      if (!acc[pasta]) {
        acc[pasta] = [];
      }
      acc[pasta].push(documento);
      return acc;
    }, {} as { [key: string]: any[] });

    this.documentosAgrupados = Object.keys(grupos).map(pasta => ({
      pasta,
      documentos: grupos[pasta],
      aberta: false
    }));
  }

  togglePasta(grupo: any) {
    grupo.aberta = !grupo.aberta;
  }

  preencherLista(listaItens: ItemDocumento[]){
    this.linhas = [];
    for(let item of (listaItens || [])) {
      let stringArray: string[] = [];
      const id = item.id.toString();
      const descricao = item?.descricao ?? '—';
      const processoTitulo = item?.processo ?? '—';
      const extensao = item?.extensao ?? '—';
      const data = this.datePipe.transform(item?.dataCadastro ?? null, 'dd/MM/yyyy') as string ?? '—';
      stringArray.push(id, descricao, processoTitulo, extensao, data);
      this.linhas.push(stringArray);
    }
  }

  baixarDocumento(id: number, descricao: string) {
    this.loading = true;
    this.documentoService.downloadDocumento(id)
      .pipe(finalize(() => this.loading = false))
      .subscribe({
        next: (response: any) => {
          if (response.sucesso && response.dados) {
            const link = document.createElement('a');
            link.href = response.dados;
            link.target = '_blank';
            link.download = descricao;
            link.click();
          } else {
            this.toastr.error(response.mensagem || "Erro ao obter o link de download");
          }
        },
        error: (error: any) => {
          this.toastr.error("Erro ao baixar o documento");
        }
      });
  }

  removerDocumento(id: number) {
    Swal.fire({
      title: 'Deseja realmente remover este documento?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#dc3545',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.documentoService.deletar(id)
          .pipe(finalize(() => this.loading = false))
          .subscribe({
            next: (response: any) => {
              if (response.sucesso) {
                this.toastr.success("Documento removido com sucesso");
                this.buscarListaDocumentoProcesso();
              } else {
                this.toastr.error(response.mensagem || "Erro ao remover o documento");
              }
            },
            error: (error: any) => {
              this.toastr.error("Erro ao remover o documento - HTTP " + error.status);
            }
          });
      }
    });
  }
}
